import { makeStyles } from '@material-ui/core/styles';

const font = {
    fontFamily: 'Varela Round, sans-serif, Regular',
    color: '#011E23',
    letterSpacing: 0,
    opacity: 1,
};

export const useNewEditCommentStyles = makeStyles({

    editComment: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },

    title: {
        ...font,
        fontSize: '24px',
        lineHeight: '29px',
        marginBottom: '24px',
        marginTop: '24px',
    },

    divider: {
        width: '100%',
    },

    inputsHolder: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '552px',
        paddingLeft: '44px',
        paddingRight: '44px',
        paddingBottom: '64px',
    },

    // fileHolder: {
    //     width: '-webkit-fill-available',
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     minHeight: '114px',
    //     background: '#FCFCFC 0% 0% no-repeat padding-box',
    //     border: '1px solid #011E23',
    //     borderRadius: '12px',
    //     opacity: 1,
    //     marginTop: '64px',
    //     padding: '20px',
    // },

    inputHolder: {
        display: 'flex',
        alignItems: 'center',
        width: '552px',
        height: '196px',
        background: '#FCFCFC 0% 0% no-repeat padding-box',
        border: '1px solid #011E23',
        borderRadius: '12px',
        opacity: 1,
        marginBottom: '8px',
        overflow: 'auto',
    },

    // newInputHolder: {
    //     width: '552px',
    //     height: '196px',
    // },

    caractersHolder: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '64px',
        width: '552px',
        justifyContent: 'flex-end'
    },

    caracters: {
        ...font,
        fontSize: '12px',
        color: '#A9AAAB',
    },

    buttons: {
        width: 'inherit',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },

    anonymous: {
        display: 'flex',
        alignItems: 'center',
    },


    cancelButton: {
        ...font,
        fontSize: '16px',
        color: '#011E23',
        opacity: 1,
        borderRadius: '12px',
        width: '132px',
        textTransform: 'unset',
    },

    saveButton: {
        ...font,
        fontSize: '16px',
        color: '#FFFFFF',
        background: '#26C6DA 0% 0% no-repeat padding-box',
        borderRadius: '12px',
        opacity: 1,
        textTransform: 'unset',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: '#26C6DA',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        width: '132px'
    },

});
